import React from 'react';

import Link from '@dashboard/components/mui-atoms/Link';
import { CUSTOM_COLORS } from '@dashboard/contexts/ThemeManager/theme';
import useLocalStorage from '@dashboard/hooks/useLocalStorage';
import { Button, Snackbar, Stack, Typography } from '@mui/material';

export default function OnboardingSnackbar(): JsxNode {
  const [isExploreSnackbarClosed, setIsExploreSnackbarClosed] = useLocalStorage('isExploreSnackbarClosed', false);

  const onClose = () => {
    setIsExploreSnackbarClosed(true);
  };

  return (
    <Snackbar
      sx={{
        maxWidth: 400,
        '.MuiSnackbarContent-root': {
          bgcolor: CUSTOM_COLORS.marketbaseGreen,
          boxShadow: 5,
          p: 3,
          borderRadius: 0,
        },
      }}
      open={!isExploreSnackbarClosed}
      message={
        <>
          <Typography variant="h4" gutterBottom>
            This is a sample workspace
          </Typography>

          <Typography>
            We encourage you to explore this sample workspace at your own pace. Whenever you&rsquo;re ready,{' '}
            <Link href="/organizations/new" color="inherit" underline="always">
              create a workspace
            </Link>{' '}
            to start building your own email templates and connecting them to your application.
          </Typography>

          <Stack direction="row" spacing={1} mt={3}>
            <Button variant="outlined" onClick={onClose} color="inherit">
              Got it
            </Button>

            <Button href="https://www.usewaypoint.com/docs/quickstart" target="_blank" color="inherit">
              View quick start guide
            </Button>
          </Stack>
        </>
      }
    />
  );
}
